import { useCallback, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import * as actionType from "../../constants/actionTypes";
import { getAll } from "../../actions/studensts";
import { tokenExpired } from "../token";

import Table from "./Table";
import Modal from "./Modal";
import JumpToModal from "./JumpToModal";
import Pagination from "./Pagination";
import Header from "./Header";
import ChagneCategory from "./ChagneCategory";
import { exportToExcel } from "../exportToExcel";
import UNAUTHORIZED from "../UNAUTHORIZED";
import ColumnNavigator from "../../components/ColumnNavigator";
import { heads } from "./Table/config";

export default function Index() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { students, count } = useSelector((state) => state.students);
  const [page, setPage] = useState(1);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [search, setSearch] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [edit, setEdit] = useState("");
  const [loading, setLoading] = useState(true);

  const [selected, setSelected] = useState();
  const [selectState, setSelectState] = useState("all");
  const [showPop, setShowPop] = useState(false);
  const [showJumpToPop, setShowJumpToPop] = useState(false);
  const [showChangeCategory, setShowChangeCategory] = useState(false);
  const tableRef = useRef(null);

  const handleNavigateToColumn = (columnIndex) => {
    if (tableRef.current) {
      tableRef.current.scrollToColumn(columnIndex);
    }
  };

  const logout = useCallback(() => {
    dispatch({ type: actionType.LOGOUT });
    navigate("/");
  }, [dispatch, navigate]);

  //the requested edit students
  const onChangeEdit = (e) => {
    if (e.target.checked) {
      setEdit("edit");
      return;
    }
    setEdit("");
  };

  // new 15/8/2022 export to excel after select state and filter students
  const getSelectState = (state) => {
    let newSelected = selectState;
    newSelected = state;
    setSelectState(newSelected);
  };

  // clear students on mount
  useEffect(() => {
    dispatch({ type: actionType.CLEAR });
    setHasSearched(false);
  }, [dispatch]);

  // update students on search, edit requests or change pages
  useEffect(() => {
    if (!hasSearched) return;
    tokenExpired(user, logout, navigate);
    setLoading(true);
    const timeOutId = setTimeout(() => {
      dispatch(getAll(page, search, edit)).finally(() => setLoading(false));
    }, 500);
    setUser(user);
    return () => clearTimeout(timeOutId);
  }, [page, search, edit, logout, navigate, dispatch, user, hasSearched]);

  // disabled the next button if in last page
  useEffect(() => {
    if (page === count?.maxPage) {
      setNextDisabled(true);
    } else {
      setNextDisabled(false);
    }
  }, [page, count?.maxPage]);

  return (
    <div>
      {user.value[0].role !== "admin" ? (
        <UNAUTHORIZED />
      ) : (
        <div>
          <h1 className="text-2xl pt-0 pl-6 pb-5 text-white">Admin Table</h1>
          <div>
            {showPop && <Modal selected={selected} setShow={setShowPop} />}
            {showJumpToPop && (
              <JumpToModal selected={selected} setShow={setShowJumpToPop} />
            )}
            {showChangeCategory && (
              <ChagneCategory
                selected={selected}
                setShow={setShowChangeCategory}
              />
            )}
            <div className="p-3">
              <Header
                selected={selected}
                setShowJumpToPop={setShowJumpToPop}
                setShowPop={setShowPop}
                setShowChangeCategory={setShowChangeCategory}
                onChangeEdit={onChangeEdit}
                setSearch={(val) => { 
                  if (val === "") {
                    // Clear everything when search is empty
                    dispatch({ type: actionType.CLEAR });
                    setHasSearched(false);
                  } else {
                    setHasSearched(true);
                  }
                  setSearch(val);
                }}
                setPage={setPage}
                getSelectState={getSelectState}
                exportState={() => exportToExcel(selectState)}
              />
            </div>
            <div className="overflow-auto p-3">
              {!hasSearched ? (
                <div className="text-center text-white p-20 text-2xl">
                  Enter Search Term to Load Data...
                </div>
              ) : loading ? (
                <div className="text-center p-20">
                  <div className="flex flex-col items-center gap-4">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-orange-500"></div>
                    <p className="text-white text-xl">Loading data, please wait...</p>
                  </div>
                </div>
              ) : students && students.length > 0 ? (
                <>
                  <div className="mb-3">
                    <ColumnNavigator columns={heads} onNavigate={handleNavigateToColumn} />
                  </div>
                  <Table
                    ref={tableRef}
                    selected={selected}
                    setSelected={setSelected}
                    students={students}
                  />
                </>
              ) : (
                <div className="text-center text-white p-20 text-2xl">
                  No results found
                </div>
              )}
            </div>
            <Pagination
              page={page}
              setPage={setPage}
              maxPage={count?.maxPage}
              nextDisabled={nextDisabled}
            />
          </div>
        </div>
      )}
    </div>
  );
}
